import React from 'react';
// selectors
import { useLanguageSelectors } from 'src/@app/reducers/languageReducer';
// error page
import { ErrorPage } from 'src/components';

const noAccessError = {
  title: 'Access Error',
  text: 'Error accessing page',
};

export const NoAccess = () => {
  const languageSelectors = useLanguageSelectors();
  const language = languageSelectors.getLanguage();
  const errorText = noAccessError;
  const noAccess = language && language.screens && language.screens.noAccess;
  if (noAccess) {
    errorText.title = noAccess.title;
    errorText.text = noAccess.errors.screenError;
  }
  return (
    <ErrorPage title={errorText.title}>
      <p>{errorText.text}</p>
    </ErrorPage>
  );
};
